// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import http from '@/utils/http';
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		tabFlag: 0,
		gjTabFlag: '',
		icpData: JSON.parse(localStorage.getItem('icpData')),
		gaData: JSON.parse(localStorage.getItem('gaData')),
		cachedComponents: 'myInfo',
		temTestquest: {},
		remepasw: {
			zh: '',
			mim: '',
		},
		appCompany: JSON.parse(localStorage.getItem('appCompany')),
		infoData: JSON.parse(localStorage.getItem('useInfo')),
		appMiniPic: JSON.parse(localStorage.getItem('appMiniPic')),
		appWxOffic: JSON.parse(localStorage.getItem('appWxOffic')),
		appLogo: JSON.parse(localStorage.getItem('appLogo')),
		appPhone: JSON.parse(localStorage.getItem('appPhone')),
		appTime: JSON.parse(localStorage.getItem('appTime')),
		hisData: [],
		txyToken: '',
	},
	mutations: {
		setInfoData(state, val) {
			state.infoData = {
				...state.infoData,
				...val
			}
			localStorage.setItem('useInfo', JSON.stringify(state.infoData))
		},
		setCachedComponents(state, val) {
			console.log('vuex:储存', val)
			state.cachedComponents = val
		},
		setAppMiniPic(state, val) {
			console.log('vuex:储存', val)
			state.appMiniPic = val
		},
		setAppWxOffic(state, val) {
			console.log('vuex:储存', val)
			state.appWxOffic = val
		},
		setAppLogo(state, val) {
			console.log('vuex:储存', val)
			state.appLogo = val
		},
		setAppPhone(state, val) {
			console.log('vuex:储存', val)
			state.appPhone = val
		},
		setAppTime(state, val) {
			console.log('vuex:储存', val)
			state.appTime = val
		},
		setAppCompany(state, val) {
			console.log('vuex:储存', val)
			state.appCompany = val
		},
		setGaData(state, val) {
			console.log('vuex:储存', val)
			state.gaData = val
		},
		setTxyToken(state, val) {
			console.log('vuex:储存', val)
			state.txyToken = val
		},
		setIcpData(state, val) {
			console.log('vuex:储存', val)
			state.icpData = val
		},
		setTemTest(state, val) {
			console.log('vuex:储存', val)
			state.temTestquest = val
		},
		setTemName(state, val) {
			console.log('vuex:修改', val)
			state.temTestquest.title = val
		},
		clearTem(state, val) {
			console.log('vuex:清空', val)
			state.temTestquest = {}
		},
		dicTemTest(state, val) {
			for (let item of state.temTestquest.examinationQuestionIdList) {
				if (item.uuid == val.uuid) {
					item.stdec = val.stdec
				}
			}
			console.log('修改成功', state.temTestquest)
		},
		gjTabFn(state, val) {
			state.gjTabFlag = val
		},
		tabFn(state, val) {
			state.tabFlag = val
		},
		addHis(state, val) {
			state.hisData.push(val)
		},
		setHis(state, val) {
			state.hisData = val
		},
		remeFn(state, val) {
			state.remepasw = {
				zh: val.zh,
				mim: val.mim,
			}
		}
	},
	actions: {
		setHisData({
			commit
		}) {
			http.get('api/app/yydSearchRecords/list')
				.then(response => {
					commit('setHis', response.data)
				})
		},
		addHisData({
			dispatch
		}, val) {
			http.post('api/app/yydSearchRecords', {
					word: val
				})
				.then(response => {
					if (response.code == 200) {
						dispatch('setHisData')
					}
				})
		},
	},
	getters: {

	},
	// 当state中的值发生改变，此时localStorage中的vuex的值会同步把state中的所有值存储起来，当页面刷新的时候，state的值会从localStorage自动获取vuex的value值，赋值到state中
	plugins: [createPersistedState({
		storage: window.sessionStorage,
		reducer(val) {
			// 此时，当count发生改变的时候，就会调用此函数，并且val的值为当前state对象，return的值为当前本地存储的value值（本地存储的key值为vuex）
			return {
				tabFlag: val.tabFlag,
				remepasw: val.remepasw,
				temTestquest: val.temTestquest,
			}
		}
	})]
});

export default store;